// extracted by mini-css-extract-plugin
export var externalLink = "_b6-0";
export var internalLinkLabel = "_b6-1";